import { ConvexAuthProvider } from "@convex-dev/auth/react";
import { ConvexReactClient } from "convex/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initPostHog } from "@repo/utils";
import { App } from "./App";

initPostHog("portail-admin");

// Bun remplace process.env.BUN_PUBLIC_* au bundle time en prod.
// En dev (si CWD mismatch), le polyfill de index.html fournit process.env = {}
// et on tombe sur la valeur locale par défaut.
const convexUrl = process.env.BUN_PUBLIC_CONVEX_URL || "http://127.0.0.1:3210";

const convex = new ConvexReactClient(convexUrl);
const elem = document.getElementById("root")!;

const app = (
  <StrictMode>
    <ConvexAuthProvider client={convex}>
      <App />
    </ConvexAuthProvider>
  </StrictMode>
);

if (import.meta.hot) {
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  createRoot(elem).render(app);
}
